import { TranslateService } from "@ngx-translate/core";

export enum ConferenceSlotType {
  InPerson = 0,
  Virtual = 1,
  Hybrid = 2
}

export namespace ConferenceSlotType {
  export function values(): ConferenceSlotType[] {
    return [
      ConferenceSlotType.InPerson, 
      ConferenceSlotType.Virtual, 
      ConferenceSlotType.Hybrid
    ];
  }
  
  export function getTranslatedLabel(slotType: ConferenceSlotType, translate: TranslateService) : string {
    switch (slotType) {
      case ConferenceSlotType.InPerson:
        return translate.instant('ConferenceSlotType.InPerson');
      case ConferenceSlotType.Virtual:
        return translate.instant('ConferenceSlotType.Virtual');
      case ConferenceSlotType.Hybrid:
        return translate.instant('ConferenceSlotType.Hybrid');
      default:
        return translate.instant('ConferenceSlotType.InPerson');
    }
  }

  export function getIcon(slotType: ConferenceSlotType): string {
    switch (slotType) {
      case ConferenceSlotType.InPerson:
        return 'icon-office';
      case ConferenceSlotType.Virtual:
        return 'icon-video-chat';
      case ConferenceSlotType.Hybrid:
        return 'icon-home-or-work';
      default:
        return 'icon-building';
    }
  }

}